/**
 * @author HungNS
 */
import * as TYPE from "./type";
import axios from "axios";
import Config from "@/services/Config";

const domain = Config.getDomain();

const axiosInstance = axios.create({
    baseURL: domain,
});

const moduleHeader = {
    namespaced: true,
    state: () => ({
        headerInfo: null,
        displayOffCanvasBtn: true,
        activeTabId: TYPE.MENU_HOME,
        isHeaderInfoInit: false,
        isAuthenticated: false,
    }),
    mutations: {
        [TYPE.SET_HEADER_INFO](state, payload) {
            state.headerInfo = payload;
            state.isHeaderInfoInit = true;
        },
        setDisplayOffCanvasBtn(state, isDisplay) {
            state.displayOffCanvasBtn = isDisplay;
        },
        setActiveTabId(state, tabId) {
            state.activeTabId = tabId;
        },
        setIsAuthenticated(state, isAuthenticated) {
            state.isAuthenticated = isAuthenticated;
        }
    },
    actions: {
        async [TYPE.GET_HEADER_INFO]({commit}) {
            const response = await axiosInstance.get("/rest/initHeader");
            commit(TYPE.SET_HEADER_INFO, response.data);
        },
        [TYPE.SET_DISPLAY_OFF_CANVAS_BTN]({commit}, isDisplay) {
            commit('setDisplayOffCanvasBtn', isDisplay);
        },
        [TYPE.SET_ACTIVE_TAB_ID]({commit}, tabId) {
            commit('setActiveTabId', tabId);
        },
        [TYPE.SET_IS_AUTHENTICATED]({commit}, isAuthenticated) {
            commit('setIsAuthenticated', isAuthenticated);
        },
    },
    getters: {
        linksAppList({headerInfo}) {
            let linksAppList = {};
            if (headerInfo) {
                linksAppList = {
                    FX_APPSTORE_URL: headerInfo.fxAppStoreUrl,
                    ST_APPSTORE_URL: headerInfo.stAppStoreUrl,
                    BO_APPSTORE_URL: headerInfo.boAppStoreUrl,
                    CRYPT_APPSTORE_URL: headerInfo.cryptAppStoreUrl,

                    FX_UNIVERSAL_LINK_URL: headerInfo.fxUniversalLinkUrl,
                    SC_UNIVERSAL_LINK_URL: headerInfo.scUniversalLinkUrl,
                    BO_UNIVERSAL_LINK_URL: headerInfo.boUniversalLinkUrl,
                    CRYPT_UNIVERSAL_LINK_URL: headerInfo.cryptUniversalLinkUrl,

                    FX_DEEP_LINK_URL: headerInfo.fxDeepLinkUrl,
                    SC_DEEP_LINK_URL: headerInfo.scDeepLinkUrl,
                    BO_DEEP_LINK_URL: headerInfo.boDeepLinkUrl,
                    CRYPT_DEEP_LINK_URL: headerInfo.cryptDeepLinkUrl,

                    FX_OPENAPP_ANDROID_URL: headerInfo.fxOpenappAndroidUrl,
                    SC_OPENAPP_ANDROID_URL: headerInfo.scOpenappAndroidUrl,
                    BO_OPENAPP_ANDROID_URL: headerInfo.boOpenappAndroidUrl,
                    CRYPT_OPENAPP_ANDROID_URL: headerInfo.cryptOpenappAndroidUrl,

                    FX_GOOGLE_PLAY_URL: headerInfo.fxGooglePlayUrl,
                    ST_GOOGLE_PLAY_URL: headerInfo.stGooglePlayUrl,
                    BO_GOOGLE_PLAY_URL: headerInfo.boGooglePlayUrl,
                    CRYPT_GOOGLE_PLAY_URL: headerInfo.cryptGooglePlayUrl,

                    GOOGLE_AUTH_ANDROID: headerInfo.googleAuthAndroidApp,
                    GOOGLE_AUTH_IOS: headerInfo.googleAuthIosApp,

                    WEBVIEW_GOOGLE_AUTHEN_APP_IOS_URL: headerInfo.webviewGoogleAuthIosApp,
                    WEBVIEW_GOOGLE_AUTHEN_APP_ANDROID_URL: headerInfo.webviewGoogleAuthAndroidApp,

                    CORPORATION_TYPE: headerInfo.corporationType,
                    FILE_UPLOAD_EXT: headerInfo.fileUploadExt,
                };
            }
            return linksAppList;
        },

        isHomeTabActive({activeTabId}) {
            return activeTabId === TYPE.MENU_HOME;
        },

        isCryptoTabActive({activeTabId}) {
            return activeTabId === TYPE.MENU_CRYPTO;
        }

    },
};
export default moduleHeader;
